import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-renderer-tdc-config',
    template: `
        <button *ngIf = "!params.node.data.ISDefault" 
        mat-mini-fab color="primary"
        tooltipPosition="top"
        pTooltip="Edit TDC Configuration"
        (click)="onClick($event)">
         <mat-icon>edit</mat-icon>
       </button>
       <button *ngIf = "!params.node.data.ISDefault"
         mat-mini-fab
         tooltipPosition="top"
         pTooltip="Delete TDC Configuration"
         color="warn"
         (click)="onClick($event)"
       >
         <mat-icon>delete</mat-icon>
       </button>
       <button 
         mat-mini-fab
         tooltipPosition="top"
         pTooltip="Data Points Integration"
         color="accent"
         (click)="onClick($event)"
         *ngIf="(params.node.data.typeId === 4 || params.node.data.typeId === 3) &&
         (params.node.data.catagoryType != 'TR' && params.node.data.catagoryType != 'SV'  && params.node.data.catagoryType != 'PV')&& !params.node.data.Manual && params.node.data.flag != 0"
       >
         <mat-icon>add</mat-icon>
       </button>
  `
})
export class BtnCellRendererTdcConfig implements ICellRendererAngularComp, OnDestroy {
    public params: any;
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        this.params = params;
    }
    onClick($event: any): any {
        if (this.params.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            };
            this.params.onClick(params);
        }
    }
    ngOnDestroy(): any {
        // no need to remove the button click handler
        // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    }
}
